import { useQuery } from '@apollo/client';
import Grid from '@mui/material/Grid2';
import makeStyles from '@mui/styles/makeStyles';
import { useContext, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../../components/Loading';
import SnackbarContext from '../../../contexts/SnackbarContext';
import { usePageTutorial } from '../../../hooks/usePageTutorial';
import { useQueryParams } from '../../../utils/useQueryParams';
import { ASSET_QUERY } from '../AssetList/operations';
import { ASSET_TEMPLATE_CONTEXT } from '../constants';
import Sidebar from '../Sidebar';
import { getAssetPageTutorialSteps } from '../tutorialSteps';
import ValuationReports from '../ValuationReports';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.sizes.fullPage,
    flexWrap: 'nowrap',
  },
  valuationsMain: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
  valuationsCenterContainer: {
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    width: '80%',
    ...theme.palette.primaryBackground,
    ...theme.palette.scrollbar,
  },
  valuationsContainer: {
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    width: '20%',
    ...theme.palette.scrollbar,
  },
}));

const AssetTemplate = () => {
  const classes = useStyles();
  const valuationsRef = useRef();
  const { setSnack } = useContext(SnackbarContext);

  const [selectedAsset, setAsset] = useState(null);
  const { legacyId, countryIsoCode } = useParams();
  const { view_mode } = useQueryParams();

  const { loading } = useQuery(ASSET_QUERY, {
    variables: { legacyId, countryIsoCode },
    errorPolicy: 'all',
    skip: !legacyId || !countryIsoCode,
    onCompleted: data => setAsset(data.asset),
    onError: error => {
      setSnack({
        severity: 'error',
        message: error.message,
        open: true,
      });
    },
  });
  usePageTutorial({
    steps: getAssetPageTutorialSteps(view_mode === 'pdf'),
    disable: !selectedAsset,
  });

  return (
    <Grid className={classes.root} container direction='column'>
      <div className={classes.valuationsMain}>
        <div ref={valuationsRef} className={classes.valuationsCenterContainer}>
          {loading ? (
            <Loading />
          ) : (
            <ValuationReports
              asset={selectedAsset}
              context={ASSET_TEMPLATE_CONTEXT}
              valuationsRef={valuationsRef}
            />
          )}
        </div>
        <div className={classes.valuationsContainer}>
          <Sidebar asset={selectedAsset} context={ASSET_TEMPLATE_CONTEXT} />
        </div>
      </div>
    </Grid>
  );
};

export default AssetTemplate;
